import { render } from "./TheHeader.vue?vue&type=template&id=10e196d3&scoped=true&bindings={\"openMenu\":\"data\"}"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=10e196d3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10e196d3"

export default script